import { getUserState, useSelector } from '../store'
import Intercom from '@intercom/messenger-js-sdk';
import dayjs from 'dayjs';

export const IntercomProvider = () => {
  const { user } = useSelector(getUserState)

  Intercom({
    app_id: 'vpay0540',
    user_id: user?.user_cognito_id,
    name: user?.user_firstname,
    email: user?.user_email,
    created_at: user?.creation_date ? dayjs(user?.creation_date).unix() : undefined,
    custom_launcher_selector: '#intercom-signup',
  });

  return null
}

